import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { useState } from "react";
import { pushCollectionAction } from "../../CollectionUtils";
const defaultSize = 4;
export const GenreFilter = (param)=>{
    let { Genres: Genres, activeGenres, updateGenre } = param;
    const [expanded, setExpanded] = useState(false);
    let uncheckedRemaining = defaultSize - activeGenres.size;
    // New text queries can be triggered with genres that have no results, we need to show those as well
    const zeroResultActiveGenres = activeGenres.filterNot((genre)=>Genres.some((g)=>g.Id === genre)).map((genre)=>({
            Id: genre,
            Name: genre,
            Count: 0
        })).toArray();
    // Sort genres by count, with active genres with zero results at the end
    const genresByCount = Genres.sort((a, b)=>b.Count - a.Count).concat(zeroResultActiveGenres);
    // When not expanded, always show active genres, and fill up with unchecked genres until defaultSize is reached
    const maybeSubset = expanded ? genresByCount : genresByCount.filter((facet)=>activeGenres.has(facet.Id) || uncheckedRemaining-- > 0);
    // Ultimately we present genres sorted alphabetically
    const toRender = maybeSubset.sort((a, b)=>a.Name.localeCompare(b.Name));
    // Don't render the filter at all if there are no genres to show
    if (toRender.length === 0) return /*#__PURE__*/ _jsx(_Fragment, {});
    const visibleGenres = toRender.map(GenreCheckbox({
        Genres: Genres,
        activeGenres,
        updateGenre
    }));
    return /*#__PURE__*/ _jsxs("div", {
        className: `c-filter__group expandable expandable--${expanded ? 'open' : 'closed'}`,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "c-filter__group-title",
                children: "Genre"
            }),
            visibleGenres,
            Genres.length > defaultSize && /*#__PURE__*/ _jsxs("button", {
                className: "c-filter__toggle",
                onClick: ()=>setExpanded((s0)=>!s0),
                children: [
                    /*#__PURE__*/ _jsx("svg", {
                        className: expanded ? ' expanded' : '',
                        width: "2.4rem",
                        height: "2.4rem",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#icon--chevron-down"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "c-filter__toggle-label",
                        children: expanded ? "Minder" : "Meer"
                    })
                ]
            })
        ]
    });
};
const GenreCheckbox = (param)=>{
    let { activeGenres, updateGenre } = param;
    return (param)=>{
        let { Id, Name, Count } = param;
        const push = pushCollectionAction();
        const checked = activeGenres.has(Id);
        const update = ()=>{
            push(`filter-genre-${checked ? 'off' : 'on'}`, Id);
            updateGenre((checked ? activeGenres.delete(Id) : activeGenres.add(Id)).toArray());
        };
        const inputId = `genre-input-${Id}`;
        const labelId = `genre-label-${Id}`;
        return /*#__PURE__*/ _jsxs("div", {
            className: "c-filter__checkbox",
            children: [
                /*#__PURE__*/ _jsx("input", {
                    id: inputId,
                    type: "checkbox",
                    checked: activeGenres.has(Id),
                    name: Name,
                    value: Id,
                    onChange: update,
                    "aria-describedby": labelId
                }),
                /*#__PURE__*/ _jsxs("label", {
                    id: labelId,
                    className: "c-filter__checkbox-label",
                    htmlFor: inputId,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "checkbox-label__name",
                            children: Name
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "checkbox-label__count",
                            children: Count
                        })
                    ]
                })
            ]
        }, `genre__${Id}`);
    };
};
